import React, { useState, useEffect } from "react";
import axios from "axios";
import { List, AutoSizer } from "react-virtualized";

function Accountant() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://68e5ff1521dd31f22cc3ac70.mockapi.io/get/user/user"
        );
        setData(res.data);
        setFilter(res.data);
      } catch (err) {
        console.error("Failed to fetch data:", err);
      }
    };
    fetchData();
  }, []);

  // Filter data based on search input
  useEffect(() => {
    const debouncing = setTimeout(() => {
      if (!search.trim()) {
        setFilter(data);
      } else {
        const filteredData = data.filter((item) =>
          item.name.toLowerCase().includes(search.toLowerCase())
        );
        setFilter(filteredData);
      }
    }, 2000);

    return () => clearTimeout(debouncing);
  }, [search, data]);

  // Row renderer for table
  const rowRenderer = ({ key, index, style }) => {
    const user = filter[index];
    if (!user) return null;

    return (
      <div
        key={key}
        style={{
          ...style,
          display: "flex",
          borderBottom: "1px solid #ccc",
          padding: "5px",
        }}
      >
        <div style={{ width: "50%" }}>{user.name}</div>
        <div style={{ width: "50%" }}>
          {new Date(user.createdAt).toLocaleString()}
        </div>
      </div>
    );
  };

  return (
    <>
      <p>Accountant</p>
    </>
   
  );
}

export default Accountant;
